export default "__VITE_ASSET__d99b5437__"